import { gql } from '@apollo/client';

export const saveConsent = gql`mutation saveConsent($params: ConsentInput!) {
  saveConsent(params: $params)
}
`